import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})

export class ResetPasswordComponent implements OnInit {
  @Input() settings: any
  @Input() data: any
  resetForm = new FormGroup({
    newpassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    comfirmpassword: new FormControl('', { validators: Validators.required, }),
  });

  isMatch: boolean;
  signing: boolean = false;
  error: boolean;
  parameters: string;
  isSubmitted: boolean = false;

  constructor(private router: Router, private httpClient: HttpClient, private route: ActivatedRoute,
    private _snackBar: MatSnackBar) { }

  ngOnInit() {

    this.parameters = this.route.snapshot.paramMap.get('params');
    if (this.parameters == null) {
      alert('reset password error');
      this.router.navigate(["/"]);
    }


  }

  openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: 2000,
    });
  }

  reset(form) {
    this.isSubmitted = true;
    this.error = false;
    if (form.invalid) { return; }
    this.signing = true;


    if (this.resetForm.controls.newpassword.value == this.resetForm.controls.comfirmpassword.value) {


      let parameters = this.parameters

      parameters = parameters.split("user")[1].trim();
      var user = parameters.split("key")[0].trim();
      var Code = parameters.split("key")[1].trim();

      var data = {
        UserId: user,
        Password: this.resetForm.controls.newpassword.value,
        ConfirmPassword: this.resetForm.controls.comfirmpassword.value,
        Code: Code
      }
      this.httpClient.post(`/Account/ResetPassword`, data).subscribe((res: any) => {
        this.openSnackBar('Password Reset Successfuly');
        if
          (this.settings.redirect && (sessionStorage.getItem("RedirectURL") && sessionStorage.getItem("RedirectURL") != 'undefined')) {
          location.href = JSON.parse(sessionStorage.getItem("RedirectURL"));
          this.router.navigate(['/']);
        }
        else
          if (this.settings.redirect && this.settings.redirectPage)
            this.router.navigate([this.settings.redirectPage]);

          else {
            this.router.navigate(['/']);
            //   setTimeout(() => { location.reload(true) }, 1000);
          }
      }, (error: any) => {
        // console.log(error)
        this.openSnackBar("Something went wrong");
      });
    } else
      this.isMatch = false;

  }
}
